<template>
  <transition name="fade">
    <TooltipWrapper
      v-if="show"
      class="no-hover"
      :position="position"
      :chartWidth="chartWidth"
      :dataWidth="dataWidth"
    >
      <template v-slot:content>
        <TooltipContent
          :title="title"
          :subtitle="subtitle"
          :content="content"/>
      </template>
    </TooltipWrapper>
  </transition>
</template>

<script>
import TooltipWrapper from './TooltipWrapper';
import TooltipContent from './TooltipContent';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    position: {
      type: Object,
    },
    chartWidth: {
      type: Number,
      required: true,
    },
    dataWidth: {
      type: Number,
      default: 0,
    },
  },
  components: {
    TooltipWrapper,
    TooltipContent,
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.no-hover{
  pointer-events: none;
}
</style>
